import "./About.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import OurTeam from "./sections/OurTeam";
import WhyChooseUs from "./sections/WhyChooseUs";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <OurStory />
      <OurTeam />
      <WhyChooseUs />
      <Footer />
    </div>;
}